// Default options for the plugin.
import videojs from 'video.js';

import PlaylistForwardButton from './PlaylistForwardButton';
import PlaylistBackButton from './PlaylistBackButton';

// Respresents the index in the control bar that the play button is at. This is important
// for positioning the forward and back buttons correctly.
const PLAYBUTTON_INDEX = 0;

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
const onPlayerReady = (player, options) => {
  player.addClass('vjs-core-playlist-ui');

  // Adding this first so our playlist index doesn't change out from under us.
  player.getChild('controlBar').addChild('PlaylistForwardButton', options, PLAYBUTTON_INDEX + 1);

  // adding AT the play button index because this will actually bump it forward.
  player.getChild('controlBar').addChild('PlaylistBackButton', options, PLAYBUTTON_INDEX);
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function share
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
function playlistControls(options) {
  onPlayerReady(this, options);
}

// Registers the necessary components and the plugin
videojs.registerComponent('PlaylistForwardButton', PlaylistForwardButton);
videojs.registerComponent('PlaylistBackButton', PlaylistBackButton);
videojs.registerPlugin('playlistControls', playlistControls);

export default playlistControls;
